import React from 'react';

const Path2 = ({ className }) => {
  return (
    <svg 
        className={className}
        width="1357" 
        height="678" 
        viewBox="0 0 1357 678" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            d="M2 2C158 2 296.059 170.754 196 241.5C-109.5 457.5 83.8232 562.399 447 507.5C705 468.5 548.417 654 695 654C816 654 814 703.5 873.5 654C899.049 632.745 670.18 611.886 967.18 501.386C1171.18 484.386 917.5 373 1355 180.5" 
            stroke="#D4A24C" 
            stroke-width="4" 
            stroke-linecap="round" 
            stroke-dasharray="8 18"
        />
    </svg>    
  );
};

export default Path2;

